module.exports = __webpack_public_path__ + "img/pic_button_start_active@2x.9ad67e68.png";